import React from 'react'
import { DefaultPlayer as Video } from 'react-html5video';
import 'react-html5video/dist/styles.css';
import Eidmaheramjan from "../images/Eid video.mp4"
import Weeding from "../images/Weeding.mp4"
import PostWeeding from "../images/Post Weeding.mp4"
function Videohtml() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <Video Play loop onCanPlayThrough={() => {
                                console.log('video play')
                            }}>
                                <source src={Eidmaheramjan} height="250px" type="video/webm" />
                            </Video>
                        </div>
                        <div className="col-md-4 mt-3">

                            <Video Play loop onCanPlayThrough={() => {
                                console.log('video play')
                            }}>
                                <source src={Weeding} height="250px" type="video/webm" />
                            </Video>
                        </div>
                        <div className="col-md-4 mt-3">

                            <Video Play loop onCanPlayThrough={() => {
                                console.log('video play')
                            }}>
                                <source src={PostWeeding} height="250px" type="video/webm" />
                            </Video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Videohtml